import React, {useEffect, useState} from 'react';
import {SocialIcon} from 'react-social-icons';
import {firestore} from '../../Firebase';
import MZAS_LOGO from '../Assets/MZAS_LOGO.svg';

function Contact() {
    const [contactData, setContactData] = useState([]);
    const [generalLinks, setGeneralLinks] = useState([]);
    const [socialLinks, setSocialLinks] = useState([]);
    
    let iconStyle = {
        "width": "3.7vw",
        "height": "3.7vw"
    }
    
    useEffect(
        () => {
            firestore.collection("Contact").onSnapshot(
                (snapShot) => (
                    setContactData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    contact: doc.data().name
                                }
                            )
                        )
                    )
                )
            )
        }, []
    )
    
    useEffect(
        () => {
            let tempSocialLinks = [];
            let tempGenralLinks = [];
            
            for (let i = 0; i < contactData.length; i++) {
                const tempStr = contactData[i]["contact"].toLocaleLowerCase();
                
                if (tempStr.includes("facebook.com") || tempStr.includes("instagram") || tempStr.includes("linkedin") || tempStr.includes("twitter") || tempStr.includes("skype") || tempStr.includes("youtube") || tempStr.includes("discord") || tempStr.includes("tiktok") || tempStr.includes("github") || tempStr.includes("reddit") || tempStr.includes("tumblr") || tempStr.includes("snapchat")) {
                    tempSocialLinks.push(contactData[i]);
                }
                else {
                    tempGenralLinks.push(contactData[i]);
                }
            }
            
            setSocialLinks(tempSocialLinks);
            setGeneralLinks(tempGenralLinks);
        }, [contactData]
    )
    
    useEffect(
        () => {
            if (contactData.length === 0) {
                let contactSection = document.getElementsByClassName("contact")[0];
                
                contactSection.style.display = "none";
            }
            else {
                let contactSection = document.getElementsByClassName("contact")[0];
                
                contactSection.style.display = "grid";
            }
        }, [contactData.length]
    )
    
    const handleContact = (link) => {
        const emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const urlRegEx = new RegExp('^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$','i');
        
        if (link.match(emailRegEx)) {
            window.open(`mailto:${link}`);
        }
        else if (urlRegEx.test(link)) {
            window.open(link, "_blank");
        }
    }
    
    return (
        <section className="contact">
            <div className="contact__logo">
                <img src={MZAS_LOGO} alt="MZAS LOGO" />
            </div>
            <div className="contact__general">
                {
                    React.Children.toArray(
                        generalLinks.map(
                            (data) => (
                                <p className="contact__general__link" onClick={() => handleContact(data.contact)}>
                                    {data.contact}
                                </p>
                            )
                        )
                    )
                }
            </div>
            <div className="contact__social">
                {
                    React.Children.toArray(
                        socialLinks.map(
                            (data) => (
                                <SocialIcon url={data.contact} label={data.contact} bgColor="white" style={iconStyle} />
                            )
                        )
                    )
                }
            </div>
        </section>
    )
}

export default Contact
